import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Checkbox, Skeleton } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { postData } from '../../../Actions/Action'
import SaveButton from '../../SaveButton'

function OtherSettingsComponent(props) {
	const dispatch = useDispatch()
	const [loading, setLoading] = useState(true)
	const [suppressOtherQuotes, setSuppressOtherQuotes] = useState(false)

	useEffect(() => {
		if (props.quoteSettings !== null && props.quoteSettings !== undefined) {
			setSuppressOtherQuotes(!!props.quoteSettings.suppress_other_quotes)
			setLoading(false)
		}
		// eslint-disable-next-line
	}, [props.quoteSettings])

	const onFinish = () => {
		const data = {
			carrierId: +props.carrierId,
			suppress_other_quotes: suppressOtherQuotes,
			settings_label: 'Other settings',
		}
		dispatch(postData(data, 'GET_QUOTE_SETTINGS', 'submit_quote_settings', props.token))
	}

	if (loading || props.quoteSettings === null || props.quoteSettings === undefined) {
		return <Skeleton active />
	}

	return (
		<Form
			layout='vertical'
			name='sac_other_settings'
			className='form-wrp'
			size='large'
			onFinish={onFinish}>

			<Row gutter={30} className='mb-4'>
				<Col xs={24}>
					<Checkbox
						checked={suppressOtherQuotes}
						onChange={e => setSuppressOtherQuotes(e.target.checked)}>
						Suppress rate quotes from other enabled carriers if the visitor chooses to bill-to their account.
					</Checkbox>
				</Col>
			</Row>

			<SaveButton />
		</Form>
	)
}

const mapStateToProps = state => ({
	quoteSettings: state.quoteSettings,
	token: state.token,
	carrierId: state.carrierId,
})

export default connect(mapStateToProps)(OtherSettingsComponent)
